import React, { useEffect, useState } from "react";
import { Calendar } from "react-calendar";
import "react-calendar/dist/Calendar.css";
import {
  LogIn,
  LogOut,
  CalendarDays,
  MessageSquare,
  Smile,
} from "lucide-react";
import { format } from "date-fns";
import MainLayout from "../components/MainLayout";
import { Link } from "react-router-dom";
import { BindAPI, BindPostAPI } from "../services/APIConnection";
import { useUserCapability } from "../components/ConstantReducerProvider";
import { Clock, Users } from "lucide-react";

const SummaryCard = ({
  onClick,
  icon,
  title,
  value = 0,
  details,
  onDetailClick,
  onValueClick,
  extraDetails,
  gradientFrom,
  gradientTo,
}) => {
  return (
    <div
      onClick={onClick}
      className={`cursor-pointer rounded-xl px-3 py-3 border ${gradientFrom} ${gradientTo} shadow-inner`}
    >
      {/* Header */}
      <div className="flex items-center justify-between mb-1">
        <h3 className="text-md font-semibold text-gray-800">{title}</h3>
        {icon}
      </div>

      {/* Extra Details */}
      {extraDetails && (
        <ul className="text-sm text-gray-600 space-y-0.5 mb-2">
          <li>
            Total Reviews:{" "}
            <span onClick={(e) => {
              e.stopPropagation();
              onValueClick?.(1);
            }} className="font-bold text-gray-800">
              {extraDetails.totalReviews ?? 0}
            </span>
          </li>
          <li>
            Average Rating:{" "}
            <span onClick={(e) => {
              e.stopPropagation(); // 🔥 prevents card click
              onValueClick?.(2);
            }} className="font-bold text-yellow-600">
              {extraDetails.averageRating ?? 0} ★
            </span>
          </li>
          <li>
            Recent Complaints:{" "}
            <span onClick={(e) => {
              e.stopPropagation(); // 🔥 prevents card click
              onValueClick?.(3);
            }} className="font-bold text-red-500">
              {extraDetails.recentComplaints ?? 0}
            </span>
          </li>
        </ul>
      )}

      {/* Details */}
      {details && (
        <div className="mt-1 space-y-0.5 text-sm text-gray-700">
          {[
            { label: "Today", key: "today" },
            { label: "This Week", key: "week" },
            { label: "This Month", key: "month" },
            { label: "This Year", key: "year" },
          ].map(({ label, key }) => (
            <div key={key} className="grid grid-cols-[120px_1fr] items-center">
              <span>{label}</span>
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  onDetailClick?.(key);
                }}
                className="font-bold text-gray-900 cursor-pointer underline text-right pr-6"
              >
                {Number(details[key] ?? 0).toLocaleString()}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// const SummaryCard1 = ({
//   icon,
//   title,
//   value,
//   details,
//   gradientFrom,
//   gradientTo,
//   onClick,
// }) => (
//   <div
//     onClick={onClick}
//     className={`relative overflow-hidden rounded-2xl shadow-md p-5 bg-white hover:shadow-xl transition-all duration-300 border-t-4 border-b-4 ${gradientFrom}`}
//   >
//     <div className="flex items-center gap-4">
//       <div className={`p-3 rounded-full bg-opacity-20 ${gradientTo}`}>
//         {icon}
//       </div>
//       <div>
//         <p className="text-sm font-semibold text-gray-500 uppercase tracking-wide">
//           {title}
//         </p>

//         {/* If simple value */}
//         {value && <p className="text-3xl font-bold text-gray-800">{value}</p>}

//         {/* If multiple details */}
//         {details && (
//           <div className="mt-1 text-gray-700 text-sm space-y-1">
//             {details.map((item, index) => (
//               <p  className="font-bold" key={index}>
//                 <span className="font-bold">{item.label}:</span>{" "}
//                 {item.value}
//               </p>
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   </div>
// );
const SummaryCard1 = ({
  icon,
  title,
  value,
  details,
  gradientFrom,
  gradientTo,
  onClick, // For single value click
  onDetailClick, // Function to handle individual detail clicks
}) => (
  <div
    className={`relative overflow-hidden rounded-2xl shadow-md p-5 bg-white hover:shadow-xl transition-all duration-300 border-t-4 border-b-4 ${gradientFrom}`}
  >
    <div className="flex items-center gap-4">
      <div className={`p-3 rounded-full bg-opacity-20 ${gradientTo}`}>
        {icon}
      </div>
      <div>
        <p className="text-sm font-bold text-black-500 uppercase tracking-wide">
          {title}
        </p>

        {/* If simple value */}
        {value && (
          <p
            onClick={onClick}
            className="cursor-pointer text-3xl font-semibold text-gray-800 underline transition-colors hover:text-blue-600"
          >
            {value}
          </p>
        )}

        {/* If multiple details */}
        {details && (
          <div className="mt-1 text-gray-700 text-sm space-y-1">
            {details.map((item, index) => (
              <p className="font-semibold" key={index}>
                <span className="font-semibold">{item.label}:</span>{" "}
                <span
                  onClick={() => item.onClick ? item.onClick() : (onDetailClick ? onDetailClick(item.key || item.label) : null)}
                  className="font-bold text-gray-900 cursor-pointer underline text-right pr-6"
                >
                  {item.value}
                </span>
              </p>
            ))}
          </div>
        )}
      </div>
    </div>
  </div>
);
const Dashboard = () => {
  const mstClientId = sessionStorage.getItem("MstClientId");
  const [bindDashBoardSplitUp, setBindDashBoardSplitUp] = useState([]);
  const [bindDashBoardSplitUp1, setBindDashBoardSplitUp1] = useState([]);
  const [bindDashBoard, setBindDashBoard] = useState([]);
  const [selectedFeedbackView, setSelectedFeedbackView] = useState(0);
  const [bindSupDashBoard, setBindSupDashBoard] = useState([]);
  const [bindBookingStatus, setBindBookingStatus] = useState([]);
  const [bindTask, setBindTask] = useState([]);
  const [bindActivity, setBindActivity] = useState([]);
  const [bindDetails, setBindDetails] = useState([]);
  const { userProfileState, dispatch } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;
  const userName =
    userProfileDatas && userProfileDatas.length > 0
      ? userProfileDatas[0].UserName
      : null;

  const [date, setDate] = useState(new Date());
  const formattedDate = format(date, "dd-MM-yyyy");

  const [bindFeedbackFormData, setBindFeedbackFormData] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopupOpen2, setIsPopupOpen2] = useState(false);
  const [isPopupOpen1, setIsPopupOpen1] = useState(false);


  const [popupType, setPopupType] = useState("");

  const [superAdminDash, setSuperAdminDash] = useState(false);
  const [clientDash, setClientDash] = useState(false);

  const availableRooms = bindDashBoardSplitUp;
  const openFeedbackPopup = (type) => {
    setPopupType(type);
    setIsPopupOpen1(true);
  };
  const handleBoxClick = async (type) => {
    debugger
    setBindDashBoardSplitUp([]);
    setPopupType(type);
    setIsPopupOpen2(true);
    // setPopupType(type);

    const clientId =
      mstClientId && mstClientId !== "null" ? parseInt(mstClientId, 10) : 0;

    const payload = {
      mstClientId: clientId,
      type,
      date,
    };

    const response = await BindPostAPI(
      payload,
      "DashboardAPI/BindDashBoardSplitUp"
    );

    const table = response?.data?.Table || [];
    const table1 = response?.data?.Table1 || [];

    setBindDashBoardSplitUp(table);

    // Type 9 → open popup2 and also load table1
    if (type === 9) {
      setBindDashBoardSplitUp1(table1);
      setIsPopupOpen2(true);
      return;
    }

    // Types 5, 8, 10, 11, 12, 13, 14 → open popup2
    const openPopup2Types = [5, 8, 10, 11, 12, 13, 14, 41, 42, 43, 44, 45];
    if (openPopup2Types.includes(type)) {
      setIsPopupOpen2(true);
      return;
    }

    // All other types → open popup1
    setIsPopupOpen(true);
  };


  const handleNumberClick = (num) => {
    setSelectedFeedbackView(num)
    setIsPopupOpen1(true);
  };
  useEffect(() => {
    getDashBoard();
    // handleBoxClick(5);
    if (userProfileDatas[0]?.MstRoleId == 1) {
      setSuperAdminDash(true);
      setClientDash(false);
    } else {
      setClientDash(true);
      setSuperAdminDash(false);
    }
  }, []);

  // Bind Dash Board
  const getDashBoard = async () => {
    let clientId = 0;
    debugger
    if (mstClientId && mstClientId !== "null") {
      clientId = parseInt(mstClientId, 10);
    }

    const today = new Date();
    const isoDate = today.toISOString();

    const data = {
      mstClientId: clientId,
      type: 0,
      // date: "2025-08-21T07:50:02.706Z"
      date: isoDate,
    };
    debugger;
    const response = await BindPostAPI(data, "DashboardAPI/BindDashBoard");
    setBindDashBoard(response.data.Table);
    debugger;
    setBindBookingStatus(response.data.Table1);
    setBindTask(response.data.Table2);
    setBindActivity(response.data.Table3);
    setBindDetails(response.data.Table4);
    setBindFeedbackFormData(response.data.Table5);

    setBindSupDashBoard(response.data.Table6);
  };

  const FEEDBACK_POPUP_TYPE = {
    TOTAL_REVIEWS: 1,
    AVERAGE_RATING: 2,
    RECENT_COMPLAINTS: 3,
  };

  console.log(userProfileDatas[0]?.MstRoleId);
  return (
    <MainLayout pageName={"1"}>
      {clientDash && (
        <div className="p-6 bg-gradient-to-br from-[#e0f7fa] via-[#e3f2fd] to-[#f1f8e9] min-h-screen">
          <div className="flex justify-between items-center mb-6">
            <h1 className="text-3xl font-bold text-gray-800">Dashboard</h1>
            <div className="text-right">
              <p className="text-sm text-gray-500">Welcome</p>
              <p className="font-semibold text-gray-800">{userName}</p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-6 mb-6">
            <SummaryCard
              title="Revenue ₹"
              // prefix="₹"
              details={{
                today: bindDashBoard?.[0]?.TodayAmount ?? 0,
                week: bindDashBoard?.[0]?.WeeklyAmount ?? 0,
                month: bindDashBoard?.[0]?.MonthlyAmount ?? 0,
                year: bindDashBoard?.[0]?.YearAmount ?? 0,
              }}
              onDetailClick={(type) => {
                if (type === "today") handleBoxClick(20, "TODAY");
                if (type === "week") handleBoxClick(3, "WEEK");
                if (type === "month") handleBoxClick(6, "MONTH");
                if (type === "year") handleBoxClick(7, "YEAR");
              }}
              gradientFrom="border-y-4 border-yellow-400"
              gradientTo="bg-yellow-50"
            />

            <SummaryCard
              title="Bookings"
              // value={bindDashBoard[0]?.Bookings || 0}
              details={{
                today: bindDashBoard?.[0]?.TodayBookings || 0,
                week: bindDashBoard?.[0]?.WeekBookings || 0,
                month: bindDashBoard?.[0]?.MonthBookings || 0,
                year: bindDashBoard?.[0]?.YearBookings || 0,
              }}
              onDetailClick={(type) => {
                if (type === "today") {
                  handleBoxClick(4, "TODAY");
                }
                if (type === "week") {
                  handleBoxClick(21, "WEEK");
                }
                if (type === "month") {
                  handleBoxClick(22, "MONTH");
                }
                if (type === "year") {
                  handleBoxClick(23, "YEAR");
                }
              }}
              gradientFrom="border-y-4 border-blue-400"
              gradientTo="bg-blue-100"
            />
            <SummaryCard
              onClick={() => handleBoxClick(6)}
              icon={<span className="text-yellow-600 text-xl"></span>}
              title="Enquiry"
              // value={bindDashBoard[0]?.ThisYear || 0}
              details={{
                today: bindDetails?.[0]?.TodayNewEnquiries || 0,
                week: bindDetails?.[0]?.WeekNewEnquiries || 0,
                month: bindDetails?.[0]?.MonthNewEnquiries || 0,
                year: bindDetails?.[0]?.YearNewEnquiries || 0,
              }}
              onDetailClick={(type) => {
                if (type === "today") {
                  handleBoxClick(24, "TODAY");
                }
                if (type === "week") {
                  handleBoxClick(25, "WEEK");
                }
                if (type === "month") {
                  handleBoxClick(26, "MONTH");
                }
                if (type === "year") {
                  handleBoxClick(27, "YEAR");
                }
              }}
              gradientFrom="border-y-4 border-green-400"
              gradientTo="bg-green-100"
            />

            <SummaryCard
              title="Cancellation"
              // value={bindDashBoard[0]?.YearCancellation || 0}
              details={{
                today: bindDetails?.[0]?.TodayCancelBookings || 0,
                week: bindDetails?.[0]?.WeekCancelBookings || 0,
                month: bindDetails?.[0]?.MonthCancelBookings || 0,
                year: bindDetails?.[0]?.YearCancelBookings || 0,
              }}
              onDetailClick={(type) => {
                if (type === "today") {
                  handleBoxClick(15, "TODAY");
                }
                if (type === "week") {
                  handleBoxClick(34, "WEEK");
                }
                if (type === "month") {
                  handleBoxClick(35, "MONTH");
                }
                if (type === "year") {
                  handleBoxClick(36, "YEAR");
                }
              }}
              gradientFrom="border-y-4 border-red-400"
              gradientTo="bg-red-100"
            />

            <SummaryCard
              title="Check-In"
              // value={bindDashBoard[0]?.CheckIns || 0}
              details={{
                today: bindDashBoard?.[0]?.TodayCheckIns || 0,
                week: bindDashBoard?.[0]?.WeekCheckIns || 0,
                month: bindDashBoard?.[0]?.MonthCheckIns || 0,
                year: bindDashBoard?.[0]?.YearCheckIns || 0,
              }}
              onDetailClick={(type) => {
                if (type === "today") {
                  handleBoxClick(1, "TODAY");
                }
                if (type === "week") {
                  handleBoxClick(28, "WEEK");
                }
                if (type === "month") {
                  handleBoxClick(29, "MONTH");
                }
                if (type === "year") {
                  handleBoxClick(30, "YEAR");
                }
              }}
              gradientFrom="border-y-4 border-green-400"
              gradientTo="bg-green-100"
            />
            <SummaryCard
              title="Check-Out"
              // value={bindDashBoard[0]?.CheckOuts || 0}
              details={{
                today: bindDashBoard?.[0]?.TodayCheckOuts || 0,
                week: bindDashBoard?.[0]?.WeekCheckOuts || 0,
                month: bindDashBoard?.[0]?.MonthCheckOuts || 0,
                year: bindDashBoard?.[0]?.YearCheckOuts || 0,
              }}
              onDetailClick={(type) => {
                if (type === "today") {
                  handleBoxClick(2, "TODAY");
                }
                if (type === "week") {
                  handleBoxClick(32, "WEEK");
                }
                if (type === "month") {
                  handleBoxClick(32, "MONTH");
                }
                if (type === "year") {
                  handleBoxClick(33, "YEAR");
                }
              }}
              gradientFrom="border-y-4 border-red-400"
              gradientTo="bg-red-100"
            />
            <SummaryCard

              title="Feedback"
              onValueClick={handleNumberClick}
              gradientFrom="border-y-4 border-blue-400"
              gradientTo="bg-blue-100"
              extraDetails={{
                totalReviews: bindDetails?.[0]?.TotalReviews || 0,
                averageRating: bindDetails?.[0]?.OverallAverage || 0,
                recentComplaints: bindDetails?.[0]?.RecentComplaints || 0,
              }}
            />
            <SummaryCard
              title="Receivables ₹"
              // prefix="₹"
              // value={bindDashBoard[0]?.YearReceivable || 0}
              details={{
                today: bindDetails?.[0]?.TodayPendingPayments || 0,
                week: bindDetails?.[0]?.WeekPendingPayments || 0,
                month: bindDetails?.[0]?.MonthPendingPayments || 0,
                year: bindDetails?.[0]?.YearPendingPayments || 0,
              }}
              onDetailClick={(type) => {
                if (type === "today") handleBoxClick(37, "TODAY");
                if (type === "week") handleBoxClick(38, "WEEK");
                if (type === "month") handleBoxClick(39, "MONTH");
                if (type === "year") handleBoxClick(40, "YEAR");
              }}
              gradientFrom="border-y-4 border-yellow-400 "
              gradientTo="bg-yellow-50"
            />
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-lg border border-gray-200 lg:col-span-2">
            <div className="flex items-center justify-center mb-4">
              {/* Calendar */}
              <div className="bg-white/80 p-6 rounded-xl shadow-md border border-gray-200 backdrop-blur-md">
                <h2 className="text-lg font-semibold mb-4">Calendar</h2>
                <Calendar
                  value={date}
                  onChange={(e) => {
                    setDate(e);
                    handleBoxClick(5);
                  }}
                  showDoubleView
                  showNeighboringMonth={false}
                  className="vacancy-calendar w-full"
                  tileClassName={({ date, view }) => {
                    if (view === "month") {
                      const formatted = format(date, "yyyy-MM-dd");
                      const availability = bindDashBoardSplitUp?.find(
                        (item) => item.date === formatted
                      );

                      if (availability) {
                        const remainingRooms =
                          availability.totalRooms - availability.bookedRooms;

                        if (remainingRooms <= 0) return "vacancy-full";
                        if (remainingRooms < 6) return "vacancy-low";
                        return "vacancy-available";
                      }
                    }
                    return "vacancy-default";
                  }}
                />
              </div>

              {/* <div className="flex items-center justify-between mb-4">
                <span className="text-sm text-gray-500">Date: {formattedDate}</span>
              </div> */}
              {isPopupOpen && (
                <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
                  <div className="bg-white w-full max-w-5xl rounded-xl shadow-lg p-6 relative">
                    {/* Header */}
                    <div className="flex justify-between items-center mb-4 border-b pb-2">
                      <h2 className="text-2xl font-bold text-gray-700">
                        {popupType === 1 && "Today's Check-ins"}
                        {popupType === 28 && "This Week's Check-ins"}
                        {popupType === 29 && "This Month Check-ins"}
                        {popupType === 30 && "This Year Check-ins"}

                        {popupType === 2 && "Today's Check-outs"}
                        {popupType === 31 && "This Week's Check-outs"}
                        {popupType === 32 && "This Month Check-outs"}
                        {popupType === 33 && "This Year Check-outs"}

                        {popupType === 20 && "This Today's Revenue"}
                        {popupType === 3 && "This Week's Revenue"}
                        {popupType === 6 && "This Month Revenue"}
                        {popupType === 7 && "This Year Revenue"}

                        {popupType === 4 && "Today's Bookings"}
                        {popupType === 21 && "This Week's Bookings"}
                        {popupType === 22 && "This Month Bookings"}
                        {popupType === 23 && "This Year Bookings"}

                        {popupType === 8 && "No of clients"}
                        {popupType === 9 && "No of Users"}
                        {popupType === 10 && "Clients Yet To Pay"}
                        {popupType === 11 && "Client Paid"}
                        {popupType === 12 &&
                          "Subscription Expiry In The Next Month"}
                        {/* {popupType === 13 && "This Month Revenue"}
                        {popupType === 14 && "This Year Revenue"} */}

                        {popupType === 15 && "Cancellation"}
                        {popupType === 34 && "This Week's Cancellation"}
                        {popupType === 35 && "This Month Cancellation"}
                        {popupType === 36 && "This Year Cancellation"}

                        {popupType === 24 && "Today's Enquiry"}
                        {popupType === 25 && "This Week's Enquiry"}
                        {popupType === 26 && "This Month Enquiry"}
                        {popupType === 27 && "This Year Enquiry"}

                        {popupType === 37 && "Today's Receivables"}
                        {popupType === 38 && "This Week's Receivables"}
                        {popupType === 39 && "This Month Receivables"}
                        {popupType === 40 && "This Year Receivables"}
                      </h2>
                      <button
                        onClick={() => setIsPopupOpen(false)}
                        className="text-gray-400 hover:text-red-500 text-xl font-bold"
                      >
                        &times;
                      </button>
                    </div>

                    <div className="max-h-80 overflow-y-auto">
                      {/* Check-ins */}
                      {(popupType === 1 ||
                        popupType === 28 ||
                        popupType === 29 ||
                        popupType === 30) && (
                          <div className="overflow-x-auto overflow-x-auto">
                            <table className="w-full border border-gray-200 rounded-lg text-sm">
                              <thead className="bg-gray-100">
                                <tr>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Guest Name
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Room Type
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Room
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Check-In
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Time
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {bindDashBoardSplitUp?.map((item, index) => (
                                  <tr
                                    key={index}
                                    className="border-t hover:bg-gray-50"
                                  >
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.GuestName}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.RoomNames}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.RoomTypes}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.CheckInDate}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.CheckInTime}
                                    </td>
                                    {/* <td className="px-4 py-2 text-gray-800">{item.CheckInTime}</td> */}
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}

                      {/* Check-outs */}
                      {(popupType === 2 ||
                        popupType === 31 ||
                        popupType === 32 ||
                        popupType === 33) && (
                          <div className="overflow-x-auto overflow-x-auto">
                            <table className="w-full border border-gray-200 rounded-lg text-sm">
                              <thead className="bg-gray-100">
                                <tr>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Guest Name
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Room Type
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Room
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Check-In
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Time
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Check-Out
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Time
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {bindDashBoardSplitUp?.map((item, index) => (
                                  <tr
                                    key={index}
                                    className="border-t hover:bg-gray-50"
                                  >
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.GuestName}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.RoomNames}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.RoomTypes}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.CheckInDate}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.CheckInTime}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.CheckOutDate}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.CheckOutTime}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}

                      {/* Bookings */}
                      {(popupType === 4 ||
                        popupType === 21 ||
                        popupType === 22 ||
                        popupType === 23) && (
                          <div className="overflow-x-auto overflow-x-auto">
                            <table className="w-full border border-gray-200 rounded-lg text-sm">
                              <thead className="bg-gray-100">
                                <tr>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Guest Name
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Room Type
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Room
                                  </th>

                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Amount Payable
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Amount Recieved
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Balance Payable
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Booking Period
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Status
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {bindDashBoardSplitUp?.map((item, index) => (
                                  <tr
                                    key={index}
                                    className="border-t hover:bg-gray-50"
                                  >
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.GuestName}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.RoomNames}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.RoomTypes}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.PayableAmount}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.PaidAmount}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.BalancePayable}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.BookingPeriod}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.Status}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}

                      {/* Enquiry */}
                      {(popupType === 24 ||
                        popupType === 25 ||
                        popupType === 26 ||
                        popupType === 27) && (
                          <div className="overflow-x-auto overflow-x-auto">
                            <table className="w-full border border-gray-200 rounded-lg text-sm">
                              {/* Header */}
                              <thead className="bg-gray-100">
                                <tr>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Guest Name
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Room Type
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Booking Period
                                  </th>
                                  <th className="text-left px-4 py-3 font-semibold text-gray-700">
                                    Status
                                  </th>
                                </tr>
                              </thead>

                              {/* Body */}
                              <tbody>
                                {bindDashBoardSplitUp?.map((item, index) => (
                                  <tr
                                    key={index}
                                    className="border-t hover:bg-gray-50"
                                  >
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.GuestName}
                                    </td>

                                    <td className="px-4 py-2 text-gray-800">
                                      {item.RoomTypes}
                                    </td>

                                    <td className="px-4 py-2 text-gray-800 whitespace-nowrap">
                                      {item.CheckInDate} - {item.CheckOutDate}
                                    </td>

                                    <td className="px-4 py-2 text-gray-800 whitespace-nowrap">
                                      {item.Status}
                                    </td>

                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}

                      {/* Revenue */}
                      {(popupType === 3 ||
                        popupType === 6 ||
                        popupType === 7 ||
                        popupType === 20) && (
                          <div className="overflow-x-auto overflow-x-auto">
                            <table className="w-full border border-gray-200 rounded-lg text-sm">
                              {/* Table Header */}
                              <thead className="bg-gray-100">
                                <tr>
                                  <th className="text-left px-4 py-2 font-semibold text-gray-700">
                                    Guest Name
                                  </th>
                                  <th className="text-left px-4 py-2 font-semibold text-gray-700">
                                    Room Type
                                  </th>
                                  <th className="text-right px-4 py-2 font-semibold text-gray-700">
                                    Amount
                                  </th>
                                </tr>
                              </thead>

                              {/* Table Body */}
                              <tbody>
                                {bindDashBoardSplitUp?.map((item, index) => (
                                  <tr key={index} className="border-t hover:bg-gray-50">
                                    <td className="px-4 py-2 text-gray-800">
                                      {item.GuestName}
                                    </td>

                                    <td className="px-4 py-2 text-gray-800 whitespace-nowrap">
                                      {item.Room}
                                    </td>

                                    <td className="px-4 py-2 text-gray-800 text-right">
                                      ₹ {Number(item.ReceivedAmount ?? 0).toLocaleString()}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>

                              {/* Table Footer */}
                              <tfoot className="bg-gray-100 font-bold">
                                <tr>
                                  <td colSpan={2} className="px-4 py-2 text-right">
                                    Total
                                  </td>
                                  <td className="px-4 py-2 text-right">
                                    ₹{" "}
                                    {bindDashBoardSplitUp
                                      ?.reduce(
                                        (sum, item) => sum + Number(item.ReceivedAmount ?? 0),
                                        0
                                      )
                                      .toLocaleString()}
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        )}


                      {/* Cancellation */}
                      {(popupType === 15 ||
                        popupType === 34 ||
                        popupType === 35 ||
                        popupType === 36) && (
                          <div className="overflow-x-auto overflow-x-auto">
                            <table className="min-w-full border border-gray-200 rounded-lg text-sm">
                              <thead className="bg-gray-100">
                                <tr>
                                  <th className="px-4 py-2 text-left font-semibold text-gray-700 whitespace-nowrap">
                                    Guest Name
                                  </th>
                                  <th className="px-4 py-2 text-right font-semibold text-gray-700 whitespace-nowrap">
                                    Booking Period
                                  </th>
                                  <th className="px-4 py-2 text-right font-semibold text-gray-700 whitespace-nowrap">
                                    Payable
                                  </th>
                                  <th className="px-4 py-2 text-right font-semibold text-gray-700 whitespace-nowrap">
                                    Paid Amount
                                  </th>
                                  <th className="px-4 py-2 text-right font-semibold text-gray-700 whitespace-nowrap">
                                    Balance Amount
                                  </th>
                                </tr>
                              </thead>

                              <tbody>
                                {bindDashBoardSplitUp?.map((item, index) => (
                                  <tr
                                    key={index}
                                    className="border-t hover:bg-gray-50"
                                  >
                                    <td className="px-4 py-2 text-gray-800 whitespace-nowrap">
                                      {item.GuestName}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800 text-right whitespace-nowrap">
                                      {item.BookingPeriod}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800 text-right whitespace-nowrap">
                                      {item.AmountPaid}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800 text-right whitespace-nowrap">
                                      {item.ReceivedAmount}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800 text-right whitespace-nowrap">
                                      {item.BalancePaid}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}
                      {/* Receivables */}
                      {(popupType === 37 ||
                        popupType === 38 ||
                        popupType === 39 ||
                        popupType === 40) && (
                          <div className="overflow-x-auto overflow-x-auto">
                            <table className="w-full border border-gray-200 rounded-lg text-sm">
                              {/* Header */}
                              <thead className="bg-gray-100">
                                <tr>
                                  <th className="text-left px-4 py-2 font-semibold text-gray-700">
                                    Guest Name
                                  </th>
                                  <th className="text-left px-4 py-2 font-semibold text-gray-700">
                                    Booking Period
                                  </th>
                                  <th className="text-right px-4 py-2 font-semibold text-gray-700">
                                    Payable
                                  </th>
                                  <th className="text-right px-4 py-2 font-semibold text-gray-700">
                                    Paid Amount
                                  </th>
                                  <th className="text-right px-4 py-2 font-semibold text-gray-700">
                                    Balance Payable
                                  </th>
                                </tr>
                              </thead>

                              {/* Body */}
                              <tbody>
                                {bindDashBoardSplitUp?.map((item, index) => (
                                  <tr
                                    key={index}
                                    className="border-t hover:bg-gray-50"
                                  >
                                    <td className="px-4 py-2 text-gray-800">
                                      {" "}
                                      {item.GuestName}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800 whitespace-nowrap">
                                      {" "}
                                      {item.BookingPeriod}{" "}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800 text-right">
                                      ₹{" "}
                                      {Number(item.Payable ?? 0).toLocaleString()}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800 text-right">
                                      ₹{" "}
                                      {Number(
                                        item.PaidAmount ?? 0
                                      ).toLocaleString()}
                                    </td>
                                    <td className="px-4 py-2 text-gray-800 text-right">
                                      ₹{" "}
                                      {Number(
                                        item.BalancePayable ?? 0
                                      ).toLocaleString()}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        )}

                      {(popupType === 13 || popupType === 14) && (
                        <div>
                          {[
                            {
                              source: "Online Booking",
                              amount: bindDashBoardSplitUp[0].OnlineAmount || 0,
                            },
                            {
                              source: "Walk-in",
                              amount: bindDashBoardSplitUp[0].CashAmount || 0,
                            },
                          ].map((item, index) => (
                            <div
                              key={index}
                              className="flex justify-between items-center bg-gray-50 hover:bg-gray-100 p-3 rounded mb-2 shadow-sm"
                            >
                              <div>
                                <p className="font-medium text-gray-800">
                                  {item.source || 0}
                                </p>
                                <p className="text-sm text-gray-600">
                                  Amount: {item.amount || 0}
                                </p>
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Footer */}
                    <div className="mt-4 flex justify-end">
                      <button
                        onClick={() => setIsPopupOpen(false)}
                        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              )}

              {/* Feedback Details */}
              {isPopupOpen1 && (
                <div className="fixed inset-0 bg-black bg-opacity-40 z-50 flex items-center justify-center">
                  <div className="bg-white rounded-xl p-6 shadow-xl w-[600px] max-h-[80vh] flex flex-col relative">
                    {/* Close Button */}
                    <button
                      onClick={() => setIsPopupOpen1(false)}
                      className="absolute top-2 right-2 text-gray-600 hover:text-black"
                    >
                      X
                    </button>

                    {/* Fixed Header */}
                    <h2 className="text-xl font-semibold mb-4">
                      {selectedFeedbackView === 1 && "Total Feedback"}
                      {selectedFeedbackView === 2 && "Average Rating"}
                      {selectedFeedbackView === 3 && "Recent Complaints"}
                    </h2>
                    {/* Scrollable Content */}
                    <div
                      className="overflow-y-auto pr-2"
                      style={{ maxHeight: "calc(80vh - 60px)" }}
                    >
                      {bindFeedbackFormData?.length > 0 ? (
                        <ul className="space-y-3">
                          {bindFeedbackFormData.map((item, index) => (
                            <li
                              key={index}
                              className="border p-4 rounded shadow-sm space-y-1"
                            >
                              {selectedFeedbackView === 3 && (
                                <>
                                  <p>
                                    <strong>ComplaintsNo:</strong> {item.ComplaintsNo || ""}
                                  </p>
                                  <p>
                                    <strong>ComplaintsDate:</strong> {item.ComplaintsDate || ""}
                                  </p>
                                  <p>
                                    <strong>BookingNo:</strong>{" "}
                                    {item.BookingNo || ""}
                                  </p>
                                  <p>
                                    <strong>BookedPerson:</strong>{" "}
                                    {item.BookedPerson || ""}
                                  </p>

                                  <hr className="my-2" />

                                  <p>
                                    <strong>BookingDate:</strong>{" "}
                                    {item.BookingDate || ""}
                                  </p>
                                  <p>
                                    <strong>GuestName:</strong>{" "}
                                    {item.GuestName || ""}
                                  </p>
                                  <p>
                                    <strong>Description:</strong>{" "}
                                    {item.Description || ""}
                                  </p></>
                              )}
                              {selectedFeedbackView === 2 && (
                                <>  <p>
                                  <strong>Memorable Moment:</strong>{" "}
                                  {item.Questions4 || ""}
                                </p>
                                  <p>
                                    <strong>Suggestions:</strong>{" "}
                                    {item.Questions5 || ""}
                                  </p>
                                  <p>
                                    <strong>Surprises:</strong>{" "}
                                    {item.Questions6 || ""}
                                  </p>
                                  <p>
                                    <strong>Felt Welcomed:</strong>{" "}
                                    {item.Questions7 || ""}
                                  </p>
                                  <p>
                                    <strong>Room Issues:</strong>{" "}
                                    {item.Questions8 || ""}
                                  </p>
                                  <p>
                                    <strong>Nature Enjoyment:</strong>{" "}
                                    {item.Questions9 || ""}
                                  </p>
                                  <p>
                                    <strong>Expectations Met:</strong>{" "}
                                    {item.Questions10 || ""}
                                  </p>
                                </>
                              )}

                              <hr className="my-2" />
                              {selectedFeedbackView === 1 && (
                                <>
                                  <p className="font-semibold">Ratings:</p>

                                  <p>
                                    Check-in:{" "}
                                    <span className="text-yellow-500">
                                      {item.CheckinProcess || 0} ★
                                    </span>
                                  </p>

                                  <p>
                                    Home Condition:{" "}
                                    <span className="text-yellow-500">
                                      {item.HomeCondition || 0} ★
                                    </span>
                                  </p>

                                  <p>
                                    Location:{" "}
                                    <span className="text-yellow-500">
                                      {item.LocationArea || 0} ★
                                    </span>
                                  </p>

                                  <p>
                                    Check-out:{" "}
                                    <span className="text-yellow-500">
                                      {item.CheckoutProcess || 0} ★
                                    </span>
                                  </p>

                                  <p>
                                    Facilities:{" "}
                                    <span className="text-yellow-500">
                                      {item.FacilitiesActivities || 0} ★
                                    </span>
                                  </p>

                                  <p>
                                    Safety & Security:{" "}
                                    <span className="text-yellow-500">
                                      {item.SafetySecurity || 0} ★
                                    </span>
                                  </p>

                                  <p>
                                    Food & Dining:{" "}
                                    <span className="text-yellow-500">
                                      {item.FoodDining || 0} ★
                                    </span>
                                  </p>

                                  <p>
                                    Recreational Activities:{" "}
                                    <span className="text-yellow-500">
                                      {item.RecreationalActivities || 0} ★
                                    </span>
                                  </p>

                                  <p>
                                    Bed & Furniture:{" "}
                                    <span className="text-yellow-500">
                                      {item.BedFurniture || 0} ★
                                    </span>
                                  </p>

                                  <p>
                                    Peaceful & Relaxing:{" "}
                                    <span className="text-yellow-500">
                                      {item.PeacefulRelaxing || 0} ★
                                    </span>
                                  </p>

                                  <hr className="my-2" />

                                  <p>
                                    <strong>Overall Comment:</strong> {item.Suggestion}
                                  </p>

                                  <p className="text-xs text-gray-400">
                                    Submitted on: {item.Date}
                                  </p>
                                </>
                              )}
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <p className="text-gray-500">No feedback found.</p>
                      )}
                    </div>
                  </div>
                </div>
              )}

              {/* </div> */}
            </div>
            {availableRooms.length > 0 && (
              <div className="bg-white rounded-xl p-4 border shadow-inner mb-6">
                <p className="text-lg font-semibold p-4 border text-gray-700 mb-6">
                  Available:{" "}
                  <span className="font-bold text-green-700">
                    {
                      availableRooms.filter((r) => r.RoomStatus === "Available")
                        .length
                    }
                  </span>
                </p>

                <div className="grid grid-cols-4 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-10 gap-2">
                  {availableRooms.map((villa, idx) => {
                    const isBooked = villa.RoomStatus === "Booked";

                    return (
                      <Link
                        key={idx}
                        to={isBooked ? "#" : "/enquiry"}
                        title={villa.Description || "No description available"}
                        className={`
            w-[90px] h-[70px]
            rounded-md border
            flex flex-col items-center justify-between
            py-2 text-center shadow-sm transition
            ${isBooked
                            ? "bg-red-200 border-red-700 text-red-800 cursor-not-allowed"
                            : "bg-green-200 border-green-700 hover:bg-green-100"
                          }
          `}
                      >
                        {/* Room Type */}
                        <p className="text-[10px] font-medium leading-tight">
                          {villa.RoomType}
                        </p>

                        {/* Room Name */}
                        <p className="text-[13px] font-semibold leading-none">
                          {villa.RoomName}
                        </p>

                        {/* Status */}
                        <p
                          className={`text-[9px] font-bold ${isBooked ? "text-red-700" : "text-green-700"
                            }`}
                        >
                          {villa.RoomStatus}
                        </p>
                      </Link>
                    );
                  })}
                </div>
              </div>
            )}
          </div>

          <div className="mt-6 grid grid-cols-1 lg:grid-cols-2 gap-6">
            <div className="bg-grey p-6 rounded-xl shadow-md">
              <h3 className="text-md font-semibold mb-2">Tasks</h3>
              <ul className="list-disc list-inside text-sm text-gray-600 space-y-1">
                {bindTask?.map((task, index) => (
                  <li key={index}>{task.Tasks}</li>
                ))}
              </ul>
            </div>
            <div className="bg-grey p-6 rounded-xl shadow-md">
              <h3 className="text-md font-semibold mb-2">Recent Activities</h3>
              <ul className="list-disc list-inside text-sm text-gray-600 space-y-1">
                {bindActivity?.map((activity, index) => (
                  <li key={index}>{activity.ActivityMessage}</li>
                ))}
              </ul>
            </div>
          </div>

          {/* <ReservationSummary /> */}
        </div>
      )}
      {superAdminDash && (
        <div>
          <div className="p-6 bg-gradient-to-br from-[#e0f7fa] via-[#e3f2fd] to-[#f1f8e9] min-h-screen">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-3xl font-bold text-gray-800">Dashboard</h1>
              <div className="text-right">
                <p className="text-sm text-gray-500">Welcome</p>
                <p className="font-semibold text-gray-800">{userName}</p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6 mb-6">
              {/* <SummaryCard1
                onClick={() => handleBoxClick(8)}
                icon={<Users className="text-green-600 text-xl" />}
                title="No of clients"
                value={bindSupDashBoard[0]?.NoOfClients || 0}
                
                gradientFrom="border-green-400"
                gradientTo="bg-green-100"
              /> */}

              <SummaryCard1
                // onClick={() => handleBoxClick(9)}
                icon={<Users className="text-purple-600 text-xl" />}
                title=" Clients"
                gradientFrom="border-purple-400"
                gradientTo="bg-purple-600"
                details={[
                  {
                    label: "Signed Up Clients",
                    value: bindSupDashBoard[0]?.NoOfClients || 0,
                    onClick: () => handleBoxClick(8),
                  },
                  {
                    label: " Paid",
                    value: bindSupDashBoard[0]?.ClientsPaid || 0,
                    onClick: () => handleBoxClick(11),
                  },
                  {
                    label: " Yet to Pay",
                    value: bindSupDashBoard[0]?.ClientsYetToPay || 0,
                    onClick: () => handleBoxClick(10),
                  },

                ]}
              />

              <SummaryCard1

                icon={<Users className="text-purple-600 text-xl" />}
                title="Subscription Received"
                gradientFrom="border-purple-400"
                gradientTo="bg-purple-600"
                details={[
                  {
                    label: "Total",
                    value: bindSupDashBoard[0]?.TotalRevenueTillDate || 0,
                    onClick: () => handleBoxClick(44),
                  },
                  {
                    label: "This Year",
                    value: bindSupDashBoard[0]?.CurrentFYTotal || 0,
                    onClick: () => handleBoxClick(14),
                  },
                  {
                    label: "This Month",
                    value: bindSupDashBoard[0]?.CurrentMonthTotal || 0,
                    onClick: () => handleBoxClick(13),
                  }
                ]}
              />


              {/* <SummaryCard1
                onClick={() => handleBoxClick(9)}
                icon={<Users className="text-purple-600 text-xl" />}
                title="No of Users"
                gradientFrom="border-purple-400"
                gradientTo="bg-purple-600"
                details={[
                  {
                    label: "Client Admins",
                    value: bindSupDashBoard[0]?.NoOfClientAdmins || 0,
                  },
                  {
                    label: "Client Users",
                    value: bindSupDashBoard[0]?.NoOfClientUsers || 0,
                  },
                  
                ]}
              /> */}

              {/* <SummaryCard1
                onClick={() => handleBoxClick(10)}
                icon={<Users className="text-pink-600 text-xl" />}
                title="Clients Yet To Pay"
                value={bindSupDashBoard[0]?.ClientsYetToPay || 0}
                gradientFrom="border-pink-400"
                gradientTo="bg-pink-100"
              /> */}
              {/* <SummaryCard1
                onClick={() => handleBoxClick(11)}
                icon={<Users className="text-yellow-600 text-xl" />}
                title="Client Paid"
                value={bindSupDashBoard[0]?.ClientsPaid || 0}
                gradientFrom="border-blue-400"
                gradientTo="bg-blue-100"
              /> */}

              {/* <SummaryCard1
                onClick={() => handleBoxClick(12)}
                icon={<Clock className="text-yellow-600 text-xl" />}
                title="Subscription Expiry In The Next Month"
                value={bindSupDashBoard[0]?.SubscriptionExpiry || 0}
                gradientFrom="border-red-400"
                gradientTo="bg-red-100"
              /> */}
              {/* <SummaryCard1
                onClick={() => handleBoxClick(13)}
                icon={<span className="text-yellow-600 text-xl">₹</span>}
                title="This Month Revenue"
                value={bindSupDashBoard[0]?.CurrentMonthTotal || 0}
                gradientFrom="border-yellow-400"
                gradientTo="bg-yellow-100"
              />
              <SummaryCard1
                onClick={() => handleBoxClick(14)}
                icon={<span className="text-yellow-600 text-xl">₹</span>}
                title="This Year Revenue"
                value={bindSupDashBoard[0]?.CurrentFYTotal || 0}
                gradientFrom="border-yellow-400"
                gradientTo="bg-indigo-100"
              /> */}

            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
              <SummaryCard1

                icon={<Users className="text-pink-600 text-xl" />}
                title="Expired but Yet To Pay"
                details={[
                  {
                    label: "",
                    value: bindSupDashBoard[0]?.ExpiredYetToPay || 0,
                    onClick: () => handleBoxClick(47),
                  },
                ]}

                gradientFrom="border-pink-400"
                gradientTo="bg-pink-100"
              />

              <SummaryCard1
                onClick={() => handleBoxClick(46)}
                icon={<Users className="text-pink-600 text-xl" />}
                title="Expiring in Next 30 days"
                details={[
                  {
                    label: "",
                    value: bindSupDashBoard[0]?.SubscriptionExpiringNext30Days || 0,
                    onClick: () => handleBoxClick(46),
                  },
                ]}

                gradientFrom="border-pink-400"
                gradientTo="bg-pink-100"
              />


              <SummaryCard1

                icon={<Users className="text-pink-600 text-xl" />}
                title="Client yet to started"
                details={[
                  {
                    label: "",
                    value: bindSupDashBoard[0]?.ClientsYetToBeStarted  || 0,
                    onClick: () => handleBoxClick(45),
                  },
                ]}

                gradientFrom="border-pink-400"
                gradientTo="bg-pink-100"
              />
              <SummaryCard1

                icon={<Users className="text-purple-600 text-xl" />}
                title="No of Users"
                gradientFrom="border-purple-400"
                gradientTo="bg-purple-600"
                details={[
                  {
                    label: "Super Admin",
                    value: bindSupDashBoard[0]?.NoOfSuperAdmins || 0,
                    onClick: () => handleBoxClick(43),
                  },
                  {
                    label: "Client Admin",
                    value: bindSupDashBoard[0]?.NoOfClientAdmins || 0,
                    onClick: () => handleBoxClick(41)
                  },
                  {
                    label: "Client User",
                    value: bindSupDashBoard[0]?.NoOfClientUsers || 0,
                    onClick: () => handleBoxClick(17)
                  }
                ]}
              />

            </div>





            {isPopupOpen2 && (
              // <div className="fixed inset-0 bg-black bg-opacity-30 flex items-center justify-center z-50">
              <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
                <div className="relative bg-white w-[95%] max-w-6xl max-h-[85vh] rounded-xl shadow-2xl flex flex-col">
                  {/* Header */}
                  <div className="flex justify-between items-center px-6 py-4 border-b">
                    <h2 className="text-2xl font-bold text-gray-700">
                      {popupType === 8 && "Clients"}
                      {popupType === 9 && "No of Users"}
                      {popupType === 10 && "Clients Yet To Pay"}
                      {popupType === 11 && "Client Paid"}
                      {popupType === 12 &&
                        "Subscription Expiry In The Next Month"}
                      {popupType === 13 && "This Month Revenue"}
                      {popupType === 14 && "This Year Revenue"}
                    </h2>
                    <button
                      onClick={() => setIsPopupOpen2(false)}
                      className="text-gray-400 hover:text-red-500 text-xl font-bold"
                    >
                      &times;
                    </button>
                  </div>

                  {/* Content with scroll */}
                  {/* <div className="mb-6"> */}
                  <div className="flex-1 overflow-y-auto p-6">
                    {/* No of clients */}
                    {popupType === 8 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">
                          Clients
                        </h2>
                        <div className="w-full overflow-x-auto overflow-y-auto">
                          <table className="w-full text-sm text-gray-700 border-collapse min-w-[800px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3"> Name</th>
                                <th className="p-3">Property Name</th>
                                <th className="p-3">Contact Number</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">No of Users Required</th>
                                <th className="p-3">
                                  Subscription Period (Months)
                                </th>
                                <th className="p-3">
                                  Amount Paid
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                <tr
                                  key={index}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-3">{res.Name || ""}</td>
                                  <td className="p-3">
                                    {res.PropertyName || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.ContactNumber || ""}
                                  </td>
                                  <td className="p-3">{res.Email || ""}</td>
                                  <td className="p-3">
                                    {res.NoofUsersRequired || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.SubscriptionPeriodMonths || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.TotalAmount || ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    {popupType === 9 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">
                          No of Users
                        </h2>
                        <div className="w-full overflow-x-auto overflow-y-auto">
                          <table className="w-full text-sm overflow-y-auto text-gray-700 border-collapse min-w-[800px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3">Client Name</th>
                                <th className="p-3">Property Name</th>
                                <th className="p-3">Contact Number</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">No of Users Required</th>
                                <th className="p-3">
                                  Subscription Period (Months)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                <tr
                                  key={index}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-3">{res.Name || ""}</td>
                                  <td className="p-3">
                                    {res.PropertyName || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.ContactNumber || ""}
                                  </td>
                                  <td className="p-3">{res.Email || ""}</td>
                                  <td className="p-3">
                                    {res.NoofUsersRequired || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.SubscriptionPeriodMonths || ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    {/* Clients Yet To Pay */}
                    {popupType === 10 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">
                          Clients Yet To Pay
                        </h2>
                        <div className="w-full overflow-x-auto overflow-y-auto">
                          <table className="w-full text-sm text-gray-700 border-collapse min-w-[800px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3">Client Name</th>
                                <th className="p-3">Property Name</th>
                                <th className="p-3">Contact Number</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">No of Users Required</th>
                                <th className="p-3">
                                  Subscription Period (Months)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                <tr
                                  key={index}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-3">{res.Name || ""}</td>
                                  <td className="p-3">
                                    {res.PropertyName || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.ContactNumber || ""}
                                  </td>
                                  <td className="p-3">{res.Email || ""}</td>
                                  <td className="p-3">
                                    {res.NoofUsersRequired || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.SubscriptionPeriodMonths || ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* Client Paided */}
                    {popupType === 11 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">
                          Client Paid
                        </h2>
                        <div className="w-full overflow-x-auto overflow-y-auto">
                          <table className="w-full text-sm text-gray-700 border-collapse min-w-[800px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3">Client Name</th>
                                <th className="p-3">Property Name</th>
                                <th className="p-3">Contact Number</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">No of Users Required</th>
                                <th className="p-3">
                                  Subscription Period (Months)
                                </th>
                                <th className="p-3">
                                  Amount Paid
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                <tr
                                  key={index}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-3">{res.Name || ""}</td>
                                  <td className="p-3">
                                    {res.PropertyName || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.ContactNumber || ""}
                                  </td>
                                  <td className="p-3">{res.Email || ""}</td>
                                  <td className="p-3">
                                    {res.NoofUsersRequired || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.SubscriptionPeriodMonths || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.TotalAmount || ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    {/* Client Paided */}
                    {popupType === 12 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">
                          Subscription Expiry In The Next Month
                        </h2>
                        <div className="w-full overflow-x-auto overflow-y-auto">
                          <table className="w-full text-sm text-gray-700 border-collapse min-w-[800px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3">Client Name</th>
                                <th className="p-3">Property Name</th>
                                <th className="p-3">Contact Number</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">No of Users Required</th>
                                <th className="p-3">
                                  Subscription Period (Months)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                <tr
                                  key={index}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-3">{res.Name || ""}</td>
                                  <td className="p-3">
                                    {res.PropertyName || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.ContactNumber || ""}
                                  </td>
                                  <td className="p-3">{res.Email || ""}</td>
                                  <td className="p-3">
                                    {res.NoofUsersRequired || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.SubscriptionPeriodMonths || ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    {/* Client Paided */}
                    {popupType === 13 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">
                          This Month Revenue
                        </h2>
                        <div className="w-full overflow-x-auto overflow-y-auto">
                          <table className="w-full text-sm text-gray-700 border-collapse min-w-[800px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3">Client Name</th>
                                <th className="p-3">Property Name</th>
                                <th className="p-3">Contact Number</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">No of Users Required</th>
                                <th className="p-3">
                                  Subscription Period (Months)
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                <tr
                                  key={index}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-3">{res.Name || ""}</td>
                                  <td className="p-3">
                                    {res.PropertyName || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.ContactNumber || ""}
                                  </td>
                                  <td className="p-3">{res.Email || ""}</td>
                                  <td className="p-3">
                                    {res.NoofUsersRequired || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.SubscriptionPeriodMonths || ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {popupType === 44 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">
                          Total Revenue
                        </h2>
                        <div className="w-full overflow-x-auto overflow-y-auto">
                          <table className="w-full text-sm text-gray-700 border-collapse min-w-[800px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3">Client Name</th>
                                <th className="p-3">Property Name</th>
                                <th className="p-3">Contact Number</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">No of Users Required</th>
                                <th className="p-3">
                                  Subscription Period (Months)
                                </th>
                                <th className="p-3">
                                  Amount
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                <tr
                                  key={index}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-3">{res.Name || ""}</td>
                                  <td className="p-3">
                                    {res.PropertyName || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.ContactNumber || ""}
                                  </td>
                                  <td className="p-3">{res.Email || ""}</td>
                                  <td className="p-3">
                                    {res.NoofUsersRequired || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.SubscriptionPeriodMonths || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.Amount || ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {popupType === 45 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">
                          Clients Yet To Be Started
                        </h2>
                        <div className="w-full overflow-x-auto">
                          <table className="w-full text-sm text-gray-700 border-collapse min-w-[800px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3">Client Name</th>
                                <th className="p-3">Property Name</th>
                                <th className="p-3">Contact Number</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">No of Users Required</th>
                                <th className="p-3">
                                  Subscription Period (Months)
                                </th>
                                <th className="p-3">
                                  Amount
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                <tr
                                  key={index}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-3">{res.Name || ""}</td>
                                  <td className="p-3">
                                    {res.PropertyName || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.ContactNumber || ""}
                                  </td>
                                  <td className="p-3">{res.Email || ""}</td>
                                  <td className="p-3">
                                    {res.NoofUsersRequired || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.SubscriptionPeriodMonths || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.Amount || ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {popupType === 46 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">
                          Subscription Expiring Next 30Days
                        </h2>
                        <div className="w-full overflow-x-auto">
                          <table className="w-full text-sm text-gray-700 border-collapse min-w-[800px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3">Client Name</th>
                                <th className="p-3">Property Name</th>
                                <th className="p-3">Contact Number</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">No of Users Required</th>
                                <th className="p-3">
                                  Subscription Period (Months)
                                </th>
                                <th className="p-3">
                                  Expiry Date
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                <tr
                                  key={index}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-3">{res.Name || ""}</td>
                                  <td className="p-3">
                                    {res.PropertyName || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.ContactNumber || ""}
                                  </td>
                                  <td className="p-3">{res.Email || ""}</td>
                                  <td className="p-3">
                                    {res.NoofUsersRequired || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.SubscriptionPeriodMonths || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.SubscriptionPeriodTo || ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}


                    {popupType === 47 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">
                          Expired but Yet To Pay
                        </h2>
                        <div className="w-full overflow-x-auto">
                          <table className="w-full text-sm text-gray-700 border-collapse min-w-[800px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3">Client Name</th>
                                <th className="p-3">Property Name</th>
                                <th className="p-3">Contact Number</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">No of Users Required</th>
                                <th className="p-3">
                                  Subscription Period (Months)
                                </th>
                                <th className="p-3">
                                  DaysExpired
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                <tr
                                  key={index}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-3">{res.Name || ""}</td>
                                  <td className="p-3">
                                    {res.PropertyName || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.ContactNumber || ""}
                                  </td>
                                  <td className="p-3">{res.Email || ""}</td>
                                  <td className="p-3">
                                    {res.NoofUsersRequired || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.SubscriptionPeriodMonths || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.DaysExpired || ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}


                    {/* Client Paided */}
                    {popupType === 14 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">
                          This Year Revenue
                        </h2>
                        <div className="w-full overflow-x-auto">
                          <table className="w-full text-sm text-gray-700 border-collapse min-w-[800px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3">Client Name</th>
                                <th className="p-3">Property Name</th>
                                <th className="p-3">Contact Number</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">No of Users Required</th>
                                <th className="p-3">
                                  Subscription Period (Months)
                                </th>
                                <th className="p-3">
                                  Amount
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                <tr
                                  key={index}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-3">{res.Name || ""}</td>
                                  <td className="p-3">
                                    {res.PropertyName || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.ContactNumber || ""}
                                  </td>
                                  <td className="p-3">{res.Email || ""}</td>
                                  <td className="p-3">
                                    {res.NoofUsersRequired || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.SubscriptionPeriodMonths || ""}
                                  </td>
                                  <td className="p-3">
                                    {res.Amount || ""}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                    {popupType === 15 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">Super Admins</h2>
                        <div className="w-full overflow-x-auto">
                          <table className="w-full text-sm text-gray-700 border-collapse min-w-[600px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3">Client Name</th>
                                <th className="p-3">Name</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">Mobile</th>
                                <th className="p-3">Client Name</th>
                                <th className="p-3">Role</th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                <tr
                                  key={index}
                                  className="border-b hover:bg-gray-50"
                                >
                                  <td className="p-3">{res.Name || ""}</td>
                                  <td className="p-3">{res.Email || ""}</td>
                                  <td className="p-3">{res.UserMobile || ""}</td>
                                  <td className="p-3">{res.ClientName || ""}</td>
                                  <td className="p-3">{res.Role || ""}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* Client Admins */}
                    {popupType === 41 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">Client Admins</h2>
                        <div className="w-full overflow-x-auto">
                          <table className="w-full text-sm text-gray-700 border-collapse min-w-[600px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3">Name</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">Mobile</th>

                                <th className="p-3">Role</th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                <tr key={index} className="border-b hover:bg-gray-50">
                                  <td className="p-3">{res.Name || ""}</td>
                                  <td className="p-3">{res.UserEmail || ""}</td>
                                  <td className="p-3">{res.UserMobile || ""}</td>

                                  <td className="p-3">{res.Role || ""}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {popupType === 42 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">Super Admins</h2>
                        <div className="w-full overflow-x-auto">
                          <table className="w-full text-sm text-gray-700 border-collapse min-w-[600px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3">Name</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">Mobile</th>
                                <th className="p-3">Client Name</th>
                                <th className="p-3">Role</th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                <tr key={index} className="border-b hover:bg-gray-50">
                                  <td className="p-3">{res.Name || ""}</td>
                                  <td className="p-3">{res.Email || ""}</td>
                                  <td className="p-3">{res.UserMobile || ""}</td>
                                  <td className="p-3">{res.ClientName || ""}</td>
                                  <td className="p-3">{res.Role || ""}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {popupType === 43 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">Super Admins</h2>
                        <div className="w-full overflow-x-auto">
                          <table className="w-full text-sm text-gray-700 border-collapse min-w-[600px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3">Client Name</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">Mobile</th>

                                <th className="p-3">Role</th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                <tr key={index} className="border-b hover:bg-gray-50">
                                  <td className="p-3">{res.Name || ""}</td>
                                  <td className="p-3">{res.UserEmail || ""}</td>
                                  <td className="p-3">{res.UserMobile || ""}</td>

                                  <td className="p-3">{res.Role || ""}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}



                    {/* Client Users */}
                    {popupType === 17 && (
                      <div className="bg-white p-6 rounded-xl shadow-md mt-6 w-full">
                        <h2 className="text-lg font-semibold mb-4">Client Users</h2>
                        <div className="w-full overflow-x-auto">
                          <table className="w-full text-sm text-gray-700 border-collapse min-w-[600px]">
                            <thead>
                              <tr className="bg-gray-100 text-left">
                                <th className="p-3">Name</th>
                                <th className="p-3">Email</th>
                                <th className="p-3">Contact Number</th>
                                <th className="p-3">Client Name</th>
                                <th className="p-3">Role</th>
                              </tr>
                            </thead>
                            <tbody>
                              {bindDashBoardSplitUp.map((res, index) => (
                                res.Role === "ClientUser" && (
                                  <tr key={index} className="border-b hover:bg-gray-50">
                                    <td className="p-3">{res.Name || ""}</td>
                                    <td className="p-3">{res.Email || ""}</td>
                                    <td className="p-3">{res.ContactNumber || ""}</td>
                                    <td className="p-3">{res.ClientName || ""}</td>
                                    <td className="p-3">{res.Role || ""}</td>
                                  </tr>
                                )
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Footer */}
                  <div className="px-6 py-4 border-t flex justify-end">
                    <button
                      onClick={() => setIsPopupOpen2(false)}
                      className="bg-blue-600 text-white px-5 py-2 rounded hover:bg-blue-700"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default Dashboard;
